/** Capitalize the first letter of a string. */
export function capitalize(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/** Capitalize the first letter of each word (title case). */
export function titleCase(str: string): string {
  if (!str) return str;
  // Unicode-aware: `\b\w` is ASCII-only, so it turned "João" into "JoãO".
  return str.replace(
    /(^|[^\p{L}\p{M}\p{N}])(\p{L})/gu,
    (_, before: string, letter: string) => before + letter.toUpperCase(),
  );
}
